import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getUserRole } from '../utils/sessionStore';
import { useAuth } from '../context/AuthContext';

/**
 * Default-deny shell for all admin routes. Client portal paths are registered
 * outside this layout in AfterLoginRoutes.
 */
export default function AdminShell() {
  const { isLoading, isAuthenticated: authed } = useAuth();

  if (isLoading) {
    return null;
  }

  if (!authed) {
    return <Navigate to="/login" replace />;
  }

  const role = getUserRole();
  if (role === 'user') {
    return <Navigate to="/client/overview" replace />;
  }

  return <Outlet />;
}
